<template>
  <div class="scanners content">
    <div class="blockvideo">
      <div class="scanner-container" style="position: relative; width: 100%;">
        <video 
          class="camera" 
          width="100%" 
          height="200" 
          ref="camera" 
          muted 
          autoplay="autoplay" 
          playsinline="playsinline"
          style="display: block;"
        ></video>
        
        <canvas 
          ref="drawingCanvas" 
          class="scanner-canvas"
          style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; pointer-events: none;"
        ></canvas>
      </div>
      
      <canvas 
        ref="dataCanvas" 
        style="display: none;"
      ></canvas>
    </div>
    
    <div class="twobuttons">

      <button class="btn btn-scan nocopy"
        @touchstart="gotoScannerActivity(true)" 
        @touchend="gotoScannerActivity(false)"
      >
        <svg class="scan-icon" viewBox="0 0 24 24">
          <path d="M3 4h4v2H5v2H3V4zm2 12v2h2v2H3v-4h2zm14-8h-2V4h4v4h-2V8zm0 8v-2h2v4h-4v-2h2zM7 8h10v8H7V8z"/>
        </svg>
        Сканировать
    </button>
      
      <button  
        class="goToScan flash nocopy" 
        :class="{activityScannerButtonFanarik:finarik}" 
        @click="finarik = !finarik"
      >
      <svg id="Layer_1" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" data-name="Layer 1"><path d="m50 74.17a24.31 24.31 0 0 1 -12.18-45.35 1.5 1.5 0 0 1 1.51 2.59 21.32 21.32 0 1 0 10.67-2.86h-.9a1.5 1.5 0 0 1 -.13-3h1a24.31 24.31 0 0 1 0 48.62z"/><path d="m43 29.66a1.5 1.5 0 0 1 -.46-2.93c.55-.18 1.11-.34 1.67-.48a1.5 1.5 0 0 1 .72 2.92c-.49.12-1 .26-1.46.41a1.55 1.55 0 0 1 -.47.08z"/><path d="m50 21.82a1.5 1.5 0 0 1 -1.5-1.5v-11.32a1.5 1.5 0 1 1 3 0v11.32a1.5 1.5 0 0 1 -1.5 1.5z"/><path d="m91 51.5h-11.32a1.5 1.5 0 0 1 0-3h11.32a1.5 1.5 0 1 1 0 3z"/><path d="m50 92.49a1.5 1.5 0 0 1 -1.5-1.49v-11.32a1.5 1.5 0 0 1 3 0v11.32a1.5 1.5 0 0 1 -1.5 1.49z"/><path d="m20.32 51.5h-11.32a1.5 1.5 0 1 1 0-3h11.32a1.5 1.5 0 0 1 0 3z"/><path d="m71 30.51a1.45 1.45 0 0 1 -1.06-.44 1.49 1.49 0 0 1 0-2.12l8-8a1.5 1.5 0 1 1 2.12 2.12l-8 8a1.47 1.47 0 0 1 -1.06.44z"/><path d="m21 80.49a1.53 1.53 0 0 1 -1-.44 1.51 1.51 0 0 1 0-2.12l8-8a1.5 1.5 0 0 1 2.12 2.12l-8 8a1.49 1.49 0 0 1 -1.12.44z"/><path d="m79 80.49a1.49 1.49 0 0 1 -1.06-.44l-8-8a1.5 1.5 0 0 1 2.12-2.12l8 8a1.51 1.51 0 0 1 0 2.12 1.53 1.53 0 0 1 -1.06.44z"/><path d="m29 30.51a1.47 1.47 0 0 1 -1-.44l-8-8a1.5 1.5 0 1 1 2.07-2.07l8 8a1.49 1.49 0 0 1 0 2.12 1.45 1.45 0 0 1 -1.07.39z"/></svg>
      </button>
      
      <button class="reload" @click="reloadCamera()">
       <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 489.711 489.711" style="enable-background:new 0 0 489.711 489.711;" xml:space="preserve"><g><g><path d="M112.156,97.111c72.3-65.4,180.5-66.4,253.8-6.7l-58.1,2.2c-7.5,0.3-13.3,6.5-13,14c0.3,7.3,6.3,13,13.5,13 c0.2,0,0.3,0,0.5,0l89.2-3.3c7.3-0.3,13-6.2,13-13.5v-1c0-0.2,0-0.3,0-0.5v-0.1l0,0l-3.3-88.2c-0.3-7.5-6.6-13.3-14-13 c-7.5,0.3-13.3,6.5-13,14l2.1,55.3c-36.3-29.7-81-46.9-128.8-49.3c-59.2-3-116.1,17.3-160,57.1c-60.4,54.7-86,137.9-66.8,217.1 c1.5,6.2,7,10.3,13.1,10.3c1.1,0,2.1-0.1,3.2-0.4c7.2-1.8,11.7-9.1,9.9-16.3C36.656,218.211,59.056,145.111,112.156,97.111z"/><path d="M462.456,195.511c-1.8-7.2-9.1-11.7-16.3-9.9c-7.2,1.8-11.7,9.1-9.9,16.3c16.9,69.6-5.6,142.7-58.7,190.7 c-37.3,33.7-84.1,50.3-130.7,50.3c-44.5,0-88.9-15.1-124.7-44.9l58.8-5.3c7.4-0.7,12.9-7.2,12.2-14.7s-7.2-12.9-14.7-12.2l-88.9,8 c-7.4,0.7-12.9,7.2-12.2,14.7l8,88.9c0.6,7,6.5,12.3,13.4,12.3c0.4,0,0.8,0,1.2-0.1c7.4-0.7,12.9-7.2,12.2-14.7l-4.8-54.1 c36.3,29.4,80.8,46.5,128.3,48.9c3.8,0.2,7.6,0.3,11.3,0.3c55.1,0,107.5-20.2,148.7-57.4 C456.056,357.911,481.656,274.811,462.456,195.511z"/></g></g></svg>
      </button>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref, watch, onUnmounted } from 'vue'
import { notSet } from '@/controlles/general'

const props = defineProps(['format'])
const emit = defineEmits(['barcode'])
const barcodeDetector = ref(null)
const device = ref([])
const error = ref('')
const interval = ref(null)
const opendevice = ref(null)
const activityScanner = ref(false)
const finarik = ref(false)
const streamId = ref(null)
const pickaudio = typeof Audio !== 'undefined' && new Audio('/audio/scan.mp3')
const erroraudio = typeof Audio !== 'undefined' && new Audio('/audio/error.mp3')
const camera = ref(null)
const drawingCanvas = ref(null)
const drawingCtx = ref(null)
const dataCanvas = ref(null)
const dataCtx = ref(null)
const animationFrameId = ref(null)

const getScanType = () => {
  return props.format || 'default'
}

const drawScannerFrame = () => {
  if (!drawingCtx.value || !drawingCanvas.value) return
  
  const width = drawingCanvas.value.width
  const height = drawingCanvas.value.height
  
  drawingCtx.value.clearRect(0, 0, width, height)
  
  const scanType = getScanType()
  
  let scanWidth, scanHeight, scanX, scanY
  
 if (scanType === 'data_matrix' || scanType === 'qr_code') {
    
    const minDimension = Math.min(width, height)
    scanWidth = minDimension / 3
    scanHeight = minDimension 
    scanX = (width - scanWidth) / 2
    scanY = (height - scanHeight) / 2
  } else {

    scanWidth = width / 1.5
    scanHeight = scanWidth * 1.5
    scanX = (width - scanWidth) / 2
    scanY = (height - scanHeight) / 2
    
   
    if (scanHeight > height * 0.6) {
      scanHeight = height
      scanWidth = scanHeight
      scanX = (width - scanWidth) / 2
      scanY = (height - scanHeight) / 2
    }
  }
  
  drawingCtx.value.fillStyle = 'rgba(0, 0, 0, 0.6)'
  
  drawingCtx.value.fillRect(0, 0, width, scanY)
  drawingCtx.value.fillRect(0, scanY, scanX, scanHeight)
  drawingCtx.value.fillRect(scanX + scanWidth, scanY, width - (scanX + scanWidth), scanHeight)
  drawingCtx.value.fillRect(0, scanY + scanHeight, width, height - (scanY + scanHeight))
  
  const frameColor = 'rgb(255 255 255 / 81%)'
  const lineColor = (scanType === 'data_matrix' || scanType === 'qr_code') ? 'rgba(255, 255, 0, 0.7)' : 'rgba(255, 0, 0, 0.7)'
  
  drawingCtx.value.strokeStyle = frameColor
  drawingCtx.value.lineWidth = 2
  const cornerLength = 25
  
  drawingCtx.value.beginPath()
  drawingCtx.value.moveTo(scanX, scanY + cornerLength)
  drawingCtx.value.lineTo(scanX, scanY)
  drawingCtx.value.lineTo(scanX + cornerLength, scanY)
  drawingCtx.value.stroke()
  
  drawingCtx.value.beginPath()
  drawingCtx.value.moveTo(scanX + scanWidth - cornerLength, scanY)
  drawingCtx.value.lineTo(scanX + scanWidth, scanY)
  drawingCtx.value.lineTo(scanX + scanWidth, scanY + cornerLength)
  drawingCtx.value.stroke()
  
  drawingCtx.value.beginPath()
  drawingCtx.value.moveTo(scanX + scanWidth, scanY + scanHeight - cornerLength)
  drawingCtx.value.lineTo(scanX + scanWidth, scanY + scanHeight)
  drawingCtx.value.lineTo(scanX + scanWidth - cornerLength, scanY + scanHeight)
  drawingCtx.value.stroke()
  
  drawingCtx.value.beginPath()
  drawingCtx.value.moveTo(scanX + cornerLength, scanY + scanHeight)
  drawingCtx.value.lineTo(scanX, scanY + scanHeight)
  drawingCtx.value.lineTo(scanX, scanY + scanHeight - cornerLength)
  drawingCtx.value.stroke()
  
  const currentTime = performance.now()
  
  if (scanType === 'data_matrix' || scanType === 'qr_code') {
    drawingCtx.value.strokeStyle = lineColor
    drawingCtx.value.lineWidth = 3
    drawingCtx.value.lineCap = 'round'
    
    const perimeter = 2 * (scanWidth + scanHeight)
    const speed = 1500
    const position = (currentTime % speed) / speed * perimeter
    
    drawingCtx.value.beginPath()
    
    if (position < scanWidth) {
      const x = scanX + position
      const y = scanY
      drawingCtx.value.moveTo(x - 10, y)
      drawingCtx.value.lineTo(x + 10, y)
    } else if (position < scanWidth + scanHeight) {
      const yPos = position - scanWidth
      const x = scanX + scanWidth
      const y = scanY + yPos
      drawingCtx.value.moveTo(x, y - 10)
      drawingCtx.value.lineTo(x, y + 10)
    } else if (position < 2 * scanWidth + scanHeight) {
      const xPos = position - (scanWidth + scanHeight)
      const x = scanX + scanWidth - xPos
      const y = scanY + scanHeight
      drawingCtx.value.moveTo(x - 10, y)
      drawingCtx.value.lineTo(x + 10, y)
    } else {
      const yPos = position - (2 * scanWidth + scanHeight)
      const x = scanX
      const y = scanY + scanHeight - yPos
      drawingCtx.value.moveTo(x, y - 10)
      drawingCtx.value.lineTo(x, y + 10)
    }
    
    drawingCtx.value.stroke()
  } else {
   /* const linePosition = currentTime / 10 % scanHeight
    drawingCtx.value.strokeStyle = lineColor
    drawingCtx.value.lineWidth = 2
    
    drawingCtx.value.beginPath()
    drawingCtx.value.moveTo(scanX, scanY + linePosition)
    drawingCtx.value.lineTo(scanX + scanWidth, scanY + linePosition)
    drawingCtx.value.stroke() */
  }
}

const gotoScannerActivity = (data) => { 
  activityScanner.value = data 
}

const initCanvas = () => {
  if (!camera.value || !dataCanvas.value || !drawingCanvas.value) return
  
  const video = camera.value
  
  if (video.videoWidth && video.videoHeight && video.videoWidth > 0 && video.videoHeight > 0) {
    dataCanvas.value.width = video.videoWidth
    dataCanvas.value.height = video.videoHeight
    drawingCanvas.value.width = video.videoWidth
    drawingCanvas.value.height = video.videoHeight
  } else {
    const dpr = window.devicePixelRatio || 1
    const rect = video.getBoundingClientRect()
    
    dataCanvas.value.width = Math.floor(rect.width * dpr)
    dataCanvas.value.height = Math.floor(rect.height * dpr)
    drawingCanvas.value.width = Math.floor(rect.width * dpr)
    drawingCanvas.value.height = Math.floor(rect.height * dpr)
    
    dataCanvas.value.style.width = `${rect.width}px`
    dataCanvas.value.style.height = `${rect.height}px`
    drawingCanvas.value.style.width = `${rect.width}px`
    drawingCanvas.value.style.height = `${rect.height}px`
  }
  
  dataCtx.value = dataCanvas.value.getContext('2d', { willReadFrequently: true })
  drawingCtx.value = drawingCanvas.value.getContext('2d')
}

const animateScannerFrame = () => {
  if (activityScanner.value && drawingCtx.value && drawingCanvas.value && drawingCanvas.value.width > 0) {
    drawScannerFrame()
    animationFrameId.value = requestAnimationFrame(animateScannerFrame)
  }
}

const openCamera = async () => {
  try {
    const devices = await navigator.mediaDevices.enumerateDevices()
    const videoDevices = devices.filter(device => device.kind === 'videoinput')
    
    if (videoDevices.length === 0) {
      throw new Error('Камеры не найдены')
    }
    
    const selectedDevice = videoDevices[videoDevices.length - 1]
    opendevice.value = selectedDevice.deviceId

    const supportedConstraints = navigator.mediaDevices.getSupportedConstraints()
    
    const constraints = {
      video: {
        deviceId: { exact: opendevice.value },
        width: { ideal: 1920 },
        height: { ideal: 1080 },
        frameRate: { ideal: 30 },
        ...(supportedConstraints.focusMode && {
          focusMode: 'continuous'
        }),
        ...(supportedConstraints.resizeMode && {
          resizeMode: 'crop-and-scale'
        })
      },
      audio: false
    }

    window.localStream = await navigator.mediaDevices.getUserMedia(constraints)

    streamId.value = window.localStream.id
    camera.value.srcObject = window.localStream
    
    const initOnLoad = () => {
      initCanvas()
      if (activityScanner.value) {
        if (animationFrameId.value) {
          cancelAnimationFrame(animationFrameId.value)
        }
        animationFrameId.value = requestAnimationFrame(animateScannerFrame)
      }
    }
    
    if (camera.value.readyState >= 2) {
      setTimeout(initOnLoad, 100)
    } else {
      camera.value.addEventListener('loadedmetadata', initOnLoad, { once: true })
    }
    
    const videoTrack = window.localStream.getVideoTracks()[0]
    if (videoTrack && typeof videoTrack.applyConstraints === 'function') {
      try {
        await videoTrack.applyConstraints({
          advanced: [{ focusMode: 'continuous' }]
        })
      } catch (focusError) {}
    }

  } catch (error) { 
    try {
      const fallbackConstraints = {
        video: {
          facingMode: 'environment',
          width: { ideal: 1280 },
          height: { ideal: 720 }
        },
        audio: false
      }
      
      window.localStream = await navigator.mediaDevices.getUserMedia(fallbackConstraints)
      camera.value.srcObject = window.localStream
      
      const initOnLoad = () => {
        initCanvas()
        if (activityScanner.value) {
          if (animationFrameId.value) {
            cancelAnimationFrame(animationFrameId.value)
          }
          animationFrameId.value = requestAnimationFrame(animateScannerFrame)
        }
      }
      
      if (camera.value.readyState >= 2) {
        setTimeout(initOnLoad, 100)
      } else {
        camera.value.addEventListener('loadedmetadata', initOnLoad, { once: true })
      }
    } catch (fallbackError) {
      throw fallbackError
    }
  }
}

const stop = () => { 
  if (window.localStream) { 
    window.localStream.getTracks().forEach(track => track.stop()) 
  }
  if (animationFrameId.value) {
    cancelAnimationFrame(animationFrameId.value)
    animationFrameId.value = null
  }
}

const reloadCamera = async () => {
  stop()
  await openCamera()
}

const startDecoding = (a) => {
  if (a) {
    if (window.localStream && window.localStream.id !== streamId.value) {
      stop()
      openCamera()
    }
    interval.value = setInterval(decode, 500)
    if (drawingCtx.value && drawingCanvas.value && drawingCanvas.value.width > 0) {
      if (animationFrameId.value) {
        cancelAnimationFrame(animationFrameId.value)
      }
      animationFrameId.value = requestAnimationFrame(animateScannerFrame)
    }
  } else {
    clearInterval(interval.value)
    if (animationFrameId.value) {
      cancelAnimationFrame(animationFrameId.value)
      animationFrameId.value = null
    }
    if (drawingCtx.value && drawingCanvas.value && drawingCanvas.value.width > 0) {
      drawingCtx.value.clearRect(0, 0, drawingCanvas.value.width, drawingCanvas.value.height)
    }
  }
}

const decode = async () => {
  try {
    if (dataCtx.value && camera.value && dataCanvas.value && dataCanvas.value.width > 0) {
      dataCtx.value.drawImage(camera.value, 0, 0, dataCanvas.value.width, dataCanvas.value.height)
      const imageData = dataCtx.value.getImageData(0, 0, dataCanvas.value.width, dataCanvas.value.height)
      
      const formats = props.format === 'data_matrix' 
        ? ['data_matrix', 'qr_code']
        : props.format === 'qr_code'
        ? ['qr_code']
        : ['ean_13', 'ean_8', 'upc_a', 'upc_e', 'code_39', 'code_128', 'codabar']
      
      const barcodes = await barcodeDetector.value.detect(imageData)
      
      const filteredBarcodes = barcodes.filter(barcode => {
        if (!formats || formats.length === 0) return true
        return formats.includes(barcode.format.toLowerCase())
      })
      
      if (filteredBarcodes.length > 0) {
        pickaudio.play()
        startDecoding(false)
        emit('barcode', filteredBarcodes[0].rawValue)
      }
    }
  } catch (e) {}
}

watch(activityScanner, (val) => {
  if (val) {
    startDecoding(true)
  } else { 
    startDecoding(false)
  }
})

watch(finarik, async (val) => {
  if (window.localStream && window.localStream.getVideoTracks().length > 0) {
    const track = window.localStream.getVideoTracks()[0]
    const capabilities = track.getCapabilities()

    if ('torch' in capabilities) {
      try {
        await track.applyConstraints({
          advanced: [{ torch: finarik.value }]
        })
      } catch (error) {}
    }
  }
})

watch(() => props.format, (newFormat) => {
  if (activityScanner.value && drawingCtx.value && drawingCanvas.value && drawingCanvas.value.width > 0) {
    drawScannerFrame()
  }
})

onMounted(async () => {
  if (!('BarcodeDetector' in window)) {
    notSet('Ваш телефон не поддерживает сканирование')
    openCamera()
  } else {
    stop()
    barcodeDetector.value = new BarcodeDetector()
    openCamera()
  }
})

onUnmounted(() => {
  stop()
  if (animationFrameId.value) {
    cancelAnimationFrame(animationFrameId.value)
  }
})
</script>

<style scoped>
.scanners{
  width: calc(100% + 10px);
  margin-left: -5px;
  background: var(--black);
  padding-top: 20px;
}

.blockvideo {
  position: relative;
  width: 100%;
  overflow: hidden;
}

.scanner-container {
  position: relative;
  width: 100%;
  height: 200px;
}

.camera {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.scanner-canvas {
  z-index: 2;
}

select{
  margin: 10px 0px;
  padding: 5px;
  width: calc(100% - 10px);
  text-align: center;
  border:1px solid #cecece;
  border-radius: 7px;
  font-size: 18px;
}

.big_button {
  border:none;
  width: 100%;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background: var(--black);
  color: #fff;
  margin: 0;
  transition: 200ms;
  padding: 12px;
  border-radius: 8px;
  font-weight: bold;
  font-size: 16px;
}

.viewScan{
  background: #fff;
  color: #000;
  box-shadow: 0 0 10px rgba(255, 255, 255, 0.3);
}

.wi {
   font-weight: 300;
}

.twobuttons{
  display: grid;
  grid-template-columns: 1fr auto auto;
  align-items: center;
  justify-items: center;
  gap: 15px;
  width: 70%;
  margin: 0 auto;
  margin-top: 10px;
  padding-bottom: 10px;
}

.goToScan{
  width: 30px;
  background: var(--new);
  height: 30px;
  display: grid;
  align-items: center;
  justify-items: center;
  border-radius: 100%;
  transition: 500ms;
  border: 3px solid var(--new);
  box-shadow: 0px 0px 0px 3px var(--new);
  cursor: pointer;
}

.goToScan:hover {
  transform: scale(1.1);
}

.activityScannerButtonFanarik {
  background: #ffcc00;
  border-color: #ffcc00;
  box-shadow: 0px 0px 10px 3px rgba(255, 204, 0, 0.5);
}

.goToScan svg{
  width: 30px;
  height: 30px;
}

.goToScan svg path,.goToScan svg circle{
      fill: #fff;
}

.reload{
  background: var(--black);
  border: none;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  display: grid;
  align-items: center;
  justify-items: center;
  cursor: pointer;
  transition: transform 0.3s;
}

.reload:hover {
  transform: rotate(180deg);
}

.reload svg {
     width: 24px;
    height: 22px;
}

.reload svg path{
  fill:#fff;
}

@keyframes scan-line-horizontal {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(200px);
  }
}

@keyframes scan-line-square {
  0% {
    transform: translate(0, 0);
  }
  25% {
    transform: translate(100%, 0);
  }
  50% {
    transform: translate(100%, 100%);
  }
  75% {
    transform: translate(0, 100%);
  }
  100% {
    transform: translate(0, 0);
  }
}

.scanner-type-label {
  position: absolute;
  top: 10px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(0, 0, 0, 0.7);
  color: white;
  padding: 5px 15px;
  border-radius: 20px;
  font-size: 12px;
  z-index: 3;
}

.square-scanner {
  animation: scan-line-square 3s linear infinite;
}
/* Кнопка сканирования в стиле btn-icon-6 */
.btn-scan {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 10px;
  background: var(--bg-primary);
  border: none;
  border-radius: 5px;
  font-family: inherit;
  font-size: 16px;
  font-weight: 400;
  color: var(--text-primary);
  cursor: pointer;
  transition: all var(--transition-fast);
}

.btn-scan:hover {
  background: var(--bg-tertiary);
  border-color: var(--border-dark);
 
}

.btn-scan:active {
  transform: translateY(0);

}

.btn-scan .scan-icon {
  width: 20px;
  height: 20px;
  fill: var(--text-secondary);
  transition: fill var(--transition-fast);
}

.btn-scan:hover .scan-icon {
  fill: var(--accent-black);
}

/* Темная тема */
html.dark .btn-scan {
  background: var(--bg-secondary);
  border-color: var(--border-dark);
  color: var(--text-primary);
}

html.dark .btn-scan:hover {
  background: var(--bg-tertiary);
  border-color: var(--accent-black);
}

html.dark .btn-scan .scan-icon {
  fill: var(--text-tertiary);
}

html.dark .btn-scan:hover .scan-icon {
  fill: var(--accent-black);
}


.btn-scan.small {
  padding: 10px 20px;
  font-size: 14px;
  gap: 8px;
}

.btn-scan.small .scan-icon {
  width: 16px;
  height: 16px;
}


.btn-scan.block {
  width: 100%;
}


.btn-scan.accent {
  background: var(--accent-black);
  border-color: var(--accent-black);
  color: var(--text-inverse);
}

.btn-scan.accent .scan-icon {
  fill: var(--text-inverse);
}

.btn-scan.accent:hover {
  background: var(--btn-accent-hover);
  border-color: var(--btn-accent-hover);
}

.btn-scan.accent:hover .scan-icon {
  fill: var(--text-inverse);
}

</style>